import React from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"
import Link from "gatsby-link"
import { StaticQuery, graphql } from "gatsby"
import InlineSVG from "react-inlinesvg"

import LogoSpacer from "../logo-spacer"

import { ReactComponent as WorksSvg } from "../../assets/images/menu-works.svg"
import WorksStroke from "../../assets/images/menu-rollover-works.svg"

import { ReactComponent as AboutSvg } from "../../assets/images/menu-about.svg"
import AboutStroke from "../../assets/images/menu-rollover-about.svg"

import { ReactComponent as ContactsSvg } from "../../assets/images/menu-contacts.svg"
import ContactsStroke from "../../assets/images/menu-rollover-contacts.svg"

// import { ReactComponent as ArtDirectorsSvg } from "../../assets/images/menu-art-directors.svg"
// import ArtDirectorsStroke from "../../assets/images/menu-rollover-art-directors.svg"

import BackgroundTexture from "../background-texture"

const MenuItems = styled.ul`
  font-size: ${rem(40)};
  align-self: center;
  margin: auto auto;
  text-align: center;
  position: relative;
  z-index: 2;
  width: 100%;

  li {
    width: 100%;
    transform: translateY(${rem(30)});
    opacity: 0;
    transition: opacity 0.3s 0.3s, transform 0.3s 0.3s;
    text-align: center;
  }

  a {
    display: inline-block;
    vertical-align: top;
    position: relative;

    svg {
      fill: #c6c5c6;
      transition: 0.3s;
    }
  }

  .stroke {
    position: absolute;
    top: 50%;
    left: 0;
    width: 150%;
    transform: translateY(-50%);
    max-width: none;
    left: -25%;
    z-index: -1;
    pointer-events: none;

    path {
      transition: 0.5s;
      stroke: #ff2300;
      stroke-dasharray: 730;
      stroke-dashoffset: 730;
      fill: none;
    }
  }

  a.active,
  a:hover {
    svg {
      fill: #ff2300;
    }

    .stroke {
      path {
        stroke-dashoffset: 0;
      }
    }
  }

  li:not(:first-of-type) {
    margin-top: ${rem(30)};

    @media ${props => props.theme.mobileDown} {
      margin-top: ${rem(10)};
    }
  }

  ${props =>
    props.open &&
    css`
      li {
        transform: translateY(0);
        opacity: 1;

        &:nth-of-type(1) {
          transition-delay: 0.1s;
        }

        &:nth-of-type(2) {
          transition-delay: 0.2s;
        }

        &:nth-of-type(3) {
          transition-delay: 0.3s;
        }

        &:nth-of-type(4) {
          transition-delay: 0.4s;
        }
      }
    `}
`

const MenuEl = styled.div`
  position: fixed;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: #000;
  z-index: -1;
  display: flex;
  flex-direction: column;
  opacity: 0;
  transition: left 0s 0.3s, opacity 0.3s 0s;

  ${props =>
    props.open &&
    css`
      left: 0;
      opacity: 1;
      transition: left 0s 0s, opacity 0.3s 0s;
    `}
`

const BackgroundImage = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  & > div {
    height: 100%;
  }
`

const WorksLink = styled(Link)`
  width: ${rem(243)};

  @media ${props => props.theme.mobileDown} {
    width: ${rem(96)};
  }
`

const AboutLink = styled(Link)`
  width: ${rem(229)};

  @media ${props => props.theme.mobileDown} {
    width: ${rem(89)};
  }
`

const ContactsLink = styled(Link)`
  width: ${rem(343)};

  @media ${props => props.theme.mobileDown} {
    width: ${rem(134)};
  }

  .stroke {
    width: 130%;
    left: -15%;

    path {
      stroke-dasharray: 900;
      stroke-dashoffset: 900;
    }
  }
`

// const ArtDirectorsLink = styled(Link)`
//   width: ${rem(229)};

//   @media ${props => props.theme.mobileDown} {
//     width: ${rem(89)};
//   }

//   .stroke {
//     width: 140%;
//     left: -20%;

//     path {
//       stroke-dasharray: 820;
//       stroke-dashoffset: 820;
//     }
//   }
// `

const Menu = props => {
  return (
    <React.Fragment>
      <MenuEl open={props.isOpen}>
        <LogoSpacer />

        <MenuItems open={props.isOpen}>
          <li>
            <WorksLink
              activeClassName="active"
              onClick={() => {
                props.toggleMenu()
              }}
              to="/work/"
              aria-label="Work"
            >
              <WorksSvg />

              <InlineSVG className="stroke" src={WorksStroke} />
            </WorksLink>
          </li>

          <li>
            <AboutLink
              activeClassName="active"
              onClick={() => {
                props.toggleMenu()
              }}
              to="/about/"
              aria-label="About"
            >
              <AboutSvg />

              <InlineSVG className="stroke" src={AboutStroke} />
            </AboutLink>
          </li>

          <li>
            <ContactsLink
              activeClassName="active"
              onClick={() => {
                props.toggleMenu()
              }}
              to="/contact/"
              aria-label="Contacts"
            >
              <ContactsSvg />

              <InlineSVG className="stroke" src={ContactsStroke} />
            </ContactsLink>
          </li>
        </MenuItems>

        <BackgroundImage>
          {/* <BgImage fluid={props.data.bgImage.childImageSharp.fluid} /> */}
          <BackgroundTexture invert={false} />
        </BackgroundImage>
      </MenuEl>
    </React.Fragment>
  )
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        bgImage: file(relativePath: { eq: "images/background-texture.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 1920, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => <Menu data={data} {...props} />}
  />
)
